import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './Root/app';
import { unregister as unregisterServiceWorker } from './registerServiceWorker';
import GlobalStyles from './Root/styled/globalStyles';
import { ThemeProvider } from "styled-components";
import theme from './Root/styled/theme';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <App />
    </ThemeProvider>
  </BrowserRouter>,
  rootElement);

// 서비스 워커를 사용하지 않는다. 예전 빌드에서 등록된 워커가 남아 있으면
// 옛 번들을 계속 서빙하므로 제거한다.
unregisterServiceWorker();

